/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
  ErrorHandler,
  inject,
  isDevMode,
  NgModule,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, Router, RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutes } from '@app/app.routing';
import { CoreModule } from '@core/core.module';
import { environment } from '@environments/environment';
import * as Sentry from '@sentry/angular';
import { IconModule } from '@shared/modules/icon.module';
import { LOCAL_STORAGE_PREFIX } from '@shared/services/store.service';
import { provideUiTour, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';

import pkg from '../../../../package.json';
import { AppComponent } from './app.component';

Sentry.init({
  dsn: environment.sentryDsn,
  release: pkg.version,
  environment: environment.environment,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutes,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    IconModule,
    RouterModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    TourStepTemplateComponent,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { panelClass: 'rounded-container' } satisfies MatDialogConfig,
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true, canSelectNullable: true },
    },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: LOCAL_STORAGE_PREFIX, useValue: environment.projectId },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter([]),
    provideUiTour({
      enableBackdrop: true,
      backdropConfig: {
        offset: 10,
      },
    }),
  ],
})
export class AppModule {}
